module.exports = __webpack_public_path__ + "static/media/usyd_logo.280de2a4.png";